/**
 * Parse uploaded file (Excel or CSV) and return first 5 rows for preview.
 * Used by Upload Preview popup only. No API calls.
 */
import * as XLSX from 'xlsx';

const PREVIEW_ROW_COUNT = 5;

function parseCSV(text) {
  const lines = text.split(/\r?\n/).filter((line) => line.trim());
  if (lines.length === 0) return { headers: [], rows: [] };
  const headers = lines[0].split(',').map((h) => h.trim().replace(/^"|"$/g, ''));
  const rows = [];
  for (let i = 1; i < Math.min(lines.length, PREVIEW_ROW_COUNT + 1); i++) {
    const values = lines[i].split(',').map((v) => v.trim().replace(/^"|"$/g, ''));
    const row = {};
    headers.forEach((h, j) => {
      row[h] = values[j] ?? '';
    });
    rows.push(row);
  }
  return { headers, rows };
}

export function parseFileToPreview(file) {
  return new Promise((resolve, reject) => {
    const name = file.name || '';
    const isExcel = /\.(xlsx|xls)$/i.test(name);
    const isCSV = /\.csv$/i.test(name);

    if (isExcel) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const json = XLSX.utils.sheet_to_json(firstSheet, { header: 1, defval: '' });
          if (json.length === 0) {
            resolve({ headers: [], rows: [], fileName: name });
            return;
          }
          const headers = (json[0] || []).map((h) => String(h ?? '').trim());
          const rows = [];
          for (let i = 1; i < Math.min(json.length, PREVIEW_ROW_COUNT + 1); i++) {
            const arr = json[i] || [];
            const row = {};
            headers.forEach((key, j) => {
              row[key] = arr[j] !== undefined && arr[j] !== null ? String(arr[j]) : '';
            });
            rows.push(row);
          }
          resolve({ headers, rows, fileName: name });
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsArrayBuffer(file);
    } else if (isCSV) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const { headers, rows } = parseCSV(e.target.result || '');
          resolve({ headers, rows, fileName: name });
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsText(file, 'UTF-8');
    } else {
          reject(new Error('Please select an Excel (.xlsx, .xls) or CSV file'));
    }
  });
}
